module.exports = __webpack_public_path__ + "img/first-2-opened.50049a22.webp";